export enum EVENT_CREATE_FORM_DATES_TYPES {
  SINGLE_DATE = 'SINGLE_DATE',
  MULTIPLE_DATES = 'MULTIPLE_DATES',
  NO_DATES = 'NO_DATES',
}

export const TIME_FORMAT = 'HH:mm';
